module.exports = "<div id=\"account\">\n    <label>{{ 'account.select-language' | translate }}</label>\n    <select [(ngModel)]=\"localeId\">\n        <option *ngFor=\"let locale of locales\" [value]=\"locale.id\">{{ locale.label }}</option>\n    </select>\n\n    <button class=\"good\" (click)=\"save()\" [disabled]=\"submitButtonDisabled === true\">{{ 'common.save' | translate }}</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/language/language.component.html
// module id = 516
// module chunks = 0